module.exports = __webpack_public_path__ + "static/img/10.b641be1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/7/2/zh/10.png
// module id = bRA2
// module chunks = 0